var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 668,
    height: 751,
    viewBox: "0 0 668 751",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-109 -87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(109 87)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "g",
    transform: "translate(194 303)",
    fill: "#8000ff",
    fontSize: 364,
    fontFamily: "CourierNewPSMT, Courier New",
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "g")), /*#__PURE__*/React.createElement("text", {
    id: "Development",
    transform: "translate(467 710)",
    fill: "#00f6ff",
    fontSize: 30,
    fontFamily: "CourierNewPSMT, Courier New",
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Development")), /*#__PURE__*/React.createElement("text", {
    id: "T",
    transform: "translate(0 614)",
    fill: "#00f6ff",
    fontSize: 459,
    fontFamily: "PalatinoLinotype-Roman, Palatino Linotype"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")))), /*#__PURE__*/React.createElement("text", {
    id: "Web_Mobile_Blockchain",
    "data-name": "Web, Mobile, Blockchain",
    transform: "translate(345 575)",
    fill: "#eee",
    fontSize: 74,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Web,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 91
  }, "Mobile,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 182
  }, "Blockchain")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group 3.e60ac4a5.svg";
export { ForwardRef as ReactComponent };